module.exports = "/assets/67c830f0cc62eabfeb7d314dee22ae14.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/CY.png
// module id = 2410
// module chunks = 0